import PropTypes from 'prop-types';
import React from 'react';
import { Loading, LoaderTypes } from '@leegality/leegality-react-component-library';

const LoadingWrapper = ({ loaderType }) => (
  <Loading loaderType={loaderType} />
);

LoadingWrapper.defaultProps = {
  loaderType: LoaderTypes.DOTS,
};

LoadingWrapper.propTypes = {
  loaderType: PropTypes.oneOf([...Object.values(LoaderTypes)]),
};

export {
  LoadingWrapper as default,
  LoaderTypes,
};
